export enum LoanReason {
    // noinspection JSUnusedGlobalSymbols
    DebtConsolidation = 'Debt Consolidation',
    HomeImprovement = 'Home Improvement',
    Education = 'Education',
    AppliancesAndElectronics = 'Appliances and Electronics',
    Wedding = 'Wedding',
    EventOrOccasion = 'Event/Occasion',
    TravelOrHoliday = 'Travel/Holiday',
    MedicalExpenses = 'Medical Expenses',
    BusinessInvestment = 'Business Investment',
    VehiclePurchase = 'Vehicle Purchase',
    DownPayment = 'Down Payment',
    SecurityOrRentalDeposit = 'Security/Rental Deposit',
    Investment = 'Investment',
    Others = 'Others'
}